var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuIconDocs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#A0EE09",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5499 14.5C31.0746 14.5 31.4999 14.9253 31.4999 15.45V19.0191L22.951 27.5684L22.9452 31.5953L26.9792 31.6011L31.4999 27.0799V32.55C31.4999 33.0747 31.0746 33.5 30.5499 33.5H15.3499C14.8252 33.5 14.3999 33.0747 14.3999 32.55V15.45C14.3999 14.9253 14.8252 14.5 15.3499 14.5H30.5499ZM32.2392 20.9672L33.5827 22.3107L26.1934 29.7L24.8479 29.698L24.8499 28.3565L32.2392 20.9672ZM22.9499 24H18.1999V25.9H22.9499V24ZM25.7999 20.2H18.1999V22.1H25.7999V20.2Z",
    fill: "#A0EE09"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIconDocs);
export default __webpack_public_path__ + "static/media/menu-icon-docs.7ac887c8bd9631459b9bcc5791567aad.svg";
export { ForwardRef as ReactComponent };